export const parameters = {
  easterEggMaxFileSize: 1024 * 1024 * 500,
  maxFileSize: 1024 * 1024 * 100,
}
